import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import ListingSelectSeedOrPubtionScreen from "../screens/ListingSelectSeedOrPubtionScreen";
import ListingEditScreen from "../screens/ListingEditScreen";
import AddSeedScreen from "../screens/AddSeedScreen";
import ActionScreen from "../screens/ActionScreen";
import ListingDetailsSeedScreen from "../screens/ListingDetailsSeedScreen";
import UserFixoScreen from "../screens/UserFixoScreen";
import PickerActionsScreen from "../screens/PickerActionsScreen";
import AddHistoryScreen from "../screens/AddHistoryScreen";
import ViewImageScreen from "../screens/ViewImageScreen";
import WelcomeScreen from "../screens/WelcomeScreen";

const Stack = createStackNavigator();

const ShareNavigator = () => (
  <Stack.Navigator initialRouteName="Select" >
    <Stack.Screen name="Select" component={ListingSelectSeedOrPubtionScreen} options={{ headerShown: false }} />
    <Stack.Screen name="AddPublication" component={ListingEditScreen} />
    <Stack.Screen name="AddSeed" component={AddSeedScreen} />
    <Stack.Screen name="Agregar historia" component={AddHistoryScreen} />


    <Stack.Screen name="ViewImage" component={ViewImageScreen} options={{ tabBarVisible: false, headerShown: false}}  />
    <Stack.Screen name="Seed Details" component={ListingDetailsSeedScreen} options={{ tabBarVisible: false }} />
    <Stack.Screen name="Action List" component={PickerActionsScreen} />
    <Stack.Screen name="AddAction" component={ActionScreen} />
    {/* <Stack.Screen
      name="Welcome"
      component={WelcomeScreen}
      options={{ headerShown: false }}
    /> */}

    <Stack.Screen name="User Fixo" component={UserFixoScreen} options={{ headerShown: false }} />





  </Stack.Navigator>
);

export default ShareNavigator;
